import React, {useEffect, useState} from 'react';
import './style.scss';
import {isRTL} from '../../../services/userModel.js';
import classNames from 'classnames';
import EditableTable from '../EditableTable/EditableTable.jsx';
import {connect, useSelector} from 'react-redux';
import {getTranslateTitle} from '../../../utils/objects-util.js';
import convertCurrencyCodeToSymbol from "../../../utils/getCurrencySymbol.js";
import {
  reconciliationsPeriodFormatPriceModel,
  reconciliationsPeriodFormatTerritoryPriceModel,
  reconciliationsPeriodGrandTotalModel
} from "../../../models/reconciliationsSettingsTemplateModel.js";
import {withTranslation} from "react-i18next";
import {CONTROL_TYPE} from "../../../utils/enums.js";

const sortedColumn = column => {
  const columns = column?.columns;
  let result = { ...column, columns: [] };
  if (columns && columns.length > 0) {
    columns.forEach(column => {
      if ((column.colSpan && +column.colSpan < 3) || !column.colSpan) {
        result.columns.push(column);
      }
    });
  }
  return result;
};

const sortedItems = (items, column, territories, currency) => {
  let result = [];
  const currentCurrencySymbol = convertCurrencyCodeToSymbol(currency);
  let sortedItems = items ? items.map(stats => {
    const { statisticResult, ...rest } = stats;
    return {
      ...rest,
      ...statisticResult,
    };
  }) : [];

  result = territories.map((e) => reconciliationsPeriodFormatTerritoryPriceModel(e, currentCurrencySymbol, e.territoryName, items?.find((t) => t?.territoryId === e?.territoryId)));
  sortedItems = addCurrencyToData(sortedItems, currentCurrencySymbol);

  result.forEach(territory => {
    territory.depots = [];
    sortedItems.forEach(item => {
      if (territory.territoryId === item.entityId) {
        territory.depots.push({...item, tableName: item.depotName});
      }
    });

    territory.tableName = `${territory.tableName} (${territory.depots.length})`;
  });


  const sortedColumns = sortedColumn(column);
  sortedColumns.columns = sortedColumns.columns.map(e => {
    /*if (e.accessor === 'offset') {
      return { ...e, type: CONTROL_TYPE.text };
    }*/
    return e;
  });

  return { data: result, columns: sortedColumns, noTerritory: [] };
};

const RenderDepotsRows = ({ territories, territory, sortedColumns, handleMapValues, isLoading, isAllCollapsed, collapseTableTerritories }) => {
  const [isShow, setIsShow] = useState(true);

  const handleClickTerritory = () => {
    collapseTableTerritories(false);
    setIsShow((!isShow || isAllCollapsed));
  }

  return (
    <div className={classNames('reconciliationPeriodsTableRowTerritory', { hiddenRowTerritory: (!isShow || isAllCollapsed) })}>
      <div className={classNames('reconciliationPeriodsTableTerritory')}>
        <EditableTable
          model={territories.columns}
          items={[territory]}
          handleOnClick={handleClickTerritory}
          isLoading={isLoading}
          onPropChange={handleMapValues}
        />
      </div>
      <EditableTable
        model={sortedColumns}
        items={territory.depots}
        isLoading={isLoading}
        onPropChange={handleMapValues}
      />
    </div>
  );
};

const addCurrencyToData = (data, currency) => {
  return data.map((e) => {
    return reconciliationsPeriodFormatPriceModel(e, currency);
  });
}

const SectionItemReconciliationPeriodsTable = ({ item, column, onPropChange, isLoading, t }) => {

  const [territories, setTerritories] = useState({ data: [], columns: [], noTerritory: [] });
  const [sortedColumns, setSortedColumns] = useState([]);
  const [grandTotal, setGrandTotal] = useState(null);
  const [grandTotalColumns, setGrandTotalColumns] = useState(null);
  const [isAllCollapsed, setIsAllCollapsed] = useState(false);
  const config = useSelector(state => state?.reconciliations?.config);


  const handleMapValues = value => {
    const result = [];

    territories.data.forEach((territory) => {
      if(value.values[0] && territory.territoryId !== value.values[0].entityId){
        territory.depots.forEach((e) => {
          result.push(e);
        });
      }
      if(value.values[0] && territory.territoryId !== value.values[0].territoryId) {
        result.push(territory);
      }
    });

    onPropChange({ stats: [...result, ...value.values] });
  };

  useEffect(() => {
    let newItems = [];
      if(item['id']){
        newItems = sortedItems(item[column.accessor], column, item['territoryStats'], item.currency);
      }

    setTerritories(newItems);

    // eslint-disable-next-line
  }, [item, column]);

  useEffect(() => {
    if(item){
      if(item && item[column.accessor] && item[column.accessor]?.length > 0){
        const currentCurrencySymbol = convertCurrencyCodeToSymbol(item.currency);
        setGrandTotal(() => reconciliationsPeriodGrandTotalModel(item, currentCurrencySymbol, t('reconciliations.PERIODS_TABLE_GRAND_TOTAL')));

        if(territories && territories.columns?.columns) {
          const newColumnsSorted = {...territories.columns, columns: territories.columns.columns.map(e => {
              if (e.accessor === 'offset') {
                return { ...e, type: CONTROL_TYPE.text };
              }
              return e;
            })};
          setGrandTotalColumns(newColumnsSorted);
        }
      }
    }
    // eslint-disable-next-line
  }, [item, column.accessor, territories]);

  const collapseTableTerritories = (isShowAll) => {
    setIsAllCollapsed(isShowAll);
  }


  useEffect(() => {
    collapseTableTerritories(config.isCollapsedTable);

  }, [config.isCollapsedTable]);



  useEffect(() => {
    setSortedColumns(sortedColumn(column));
  }, [column]);

  return (
      <div className={classNames('reconciliationPeriods')}>
        <div className={classNames('reconciliationPeriodsTable', { rlt: isRTL(), containerTableRlt: isRTL() })}>
          <div className={classNames('reconciliationPeriodsTableBlock', {rlt: isRTL()})} style={column.width ? {width: column.width} : {}}>
            <div className={classNames("reconciliationPeriodsTableBlockTable")}>
              <table>
                <thead>
                <tr>
                  {column?.columns?.map(
                      (column, index) =>
                          !column.isChild && (
                              <th
                                  key={`headerItem-${column.title}-${index}`}
                                  className={classNames(
                                      'headerItem',
                                      {
                                        centered: column.centered,
                                      },
                                      {reconciliationPeriodsTableFixed: column.sticky},
                                      {reconciliationPeriodsTableBorder: column.colSpan > 1}
                                  )}
                                  rowSpan={column.rowSpan ? column.rowSpan : 1}
                                  colSpan={column.colSpan ? column.colSpan : 1}
                                  style={{
                                    width: column.widthHeader ? `${column.widthHeader}` : `auto`,
                                    textAlign: column.textRight ? 'right' : '',
                                  }}
                              >
                                {getTranslateTitle(column.title)}
                                &nbsp;
                              </th>
                          )
                  )}
                </tr>
                <tr>
                  {column?.columns?.map(
                      (column, index) =>
                          column.isChild && (
                              <th
                                  key={`headerItem-${column.title}-${index}`}
                                  className={classNames(
                                      'headerItem',
                                      {
                                        centered: column.centered,
                                      },
                                      {reconciliationPeriodsTableFixed: column.sticky}
                                  )}
                                  rowSpan={column.rowSpan ? column.rowSpan : 1}
                                  style={{
                                    width: column.widthHeader ? `${column.widthHeader}` : `auto`,
                                    textAlign: column.textRight ? 'right' : '',
                                  }}
                              >
                                {getTranslateTitle(column.title)}
                                &nbsp;
                              </th>
                          )
                  )}
                </tr>
                </thead>
              </table>
            </div>
            {(territories.data && territories.data.length > 0) && territories.data.map((territory, index) => (
                <div key={index}>
                  <RenderDepotsRows
                      isAllCollapsed={isAllCollapsed}
                      collapseTableTerritories={collapseTableTerritories}
                      territories={territories}
                      territory={territory}
                      sortedColumns={sortedColumns}
                      handleMapValues={handleMapValues}
                      isLoading={isLoading}
                  />
                </div>
            ))}

            {(territories && territories.noTerritory && territories.noTerritory.length > 0) &&
                <div className={'reconciliationPeriodsTableRowTerritory'}>
                  <EditableTable
                      items={territories.noTerritory}
                      model={sortedColumns}
                      isLoading={isLoading}
                      onPropChange={handleMapValues}
                  />
                </div>}
            {(grandTotal && grandTotalColumns) && <div className={'reconciliationPeriodsGrandTotalsTable'}>
              <EditableTable
                  items={[grandTotal]}
                  model={grandTotalColumns}
                  isLoading={isLoading}
                  onPropChange={handleMapValues}
              />
            </div>}
          </div>
        </div>
      </div>
  );
};

const mapStateToProps = state => {
  return {
    isLoading: state.sectionsWrapperData.isLoading,
  };
};

export default connect(mapStateToProps)(withTranslation()(SectionItemReconciliationPeriodsTable));
